export enum EnumPrecioUnitario {
  EuroskWh = 1,
  EurosDia = 2,
  EuroskWhDia = 3,
  EurosMes = 4,
  EuroskWhDiaMes = 7,
  EuroskWhDiaDia = 8,
  Porcentaje = 9,
  DolareskWh = 10,
  LibraskWh = 11,
  PTherms = 12,
  EurosMWh = 13,
  LibrasTherms = 14,
  DolaresBarril = 15,
  DolaresMMBtu = 16,
  EurosUnidad = 18,
  CentLibraMWh = 19,
  CentEurokWh = 20,
  CentDolarkWh = 21,
  CentDolarMWh = 22,
  PMWh = 23,
  CentEuroMWh = 24,
  EurosGJ = 25,
  EurosMWhDia = 26,
  DolaresUd = 35,
  EuroskW = 36,
  EuroskWDia = 37,
  EuroskWMes = 38,
  EuroskWAnio = 39,
  EuroskVArh = 40,
  DolaresMWh = 41,
  EurosKg = 42,
  Dolarestn = 43,
  EurosGJDia = 45,
  EurosAno = 46,
  EuroskWhDiaAno = 47
}
